import {
  findFeatureFlagVariants,
  type BooleanFeatureFlagKey,
  type VariantFeatureFlagKey,
} from "@repo/app-types/featureFlags/keys";
import { useSelector } from "react-redux";
import type { RootState } from "../../app/store.js";

// Reads the /boot snapshot held in the Redux `featureFlags` slice. There is no
// live flag channel: a change lands whenever the boot query refetches (mount,
// reconnect, or window focus once the snapshot is stale — see
// BOOT_STALE_TIME_MS), and a page reload always picks it up immediately.
export function useIsFeatureFlagEnabled(key: BooleanFeatureFlagKey): boolean {
  return useSelector((state: RootState) => state.featureFlags.includes(key));
}

// The variant a variant flag resolves to in the /boot snapshot (refreshed like
// `useIsFeatureFlagEnabled`'s), or its default when the snapshot has none or a
// value this bundle does not know.
export function useFeatureFlagVariant<Variant extends string>(
  key: VariantFeatureFlagKey<Variant>,
): Variant {
  const value = useSelector(
    (state: RootState) => state.featureFlagVariants[key],
  );
  const { variants, defaultVariant } = findFeatureFlagVariants(key);
  return variants.find((variant) => variant === value) ?? defaultVariant;
}
